import axios from '../utils/axios'

// 获取大淘客榜单商品列表接口
export function GetRankingList(params) {
  return axios({
    url: '/SaleV2/Dtk/GetRankingList',
    method: 'get',
    params: params
  })
}

// 获取大淘客商品详情接口
export function GetGoodsDetails(params) {
  return axios({
    url: '/SaleV2/Dtk/GetGoodsDetails',
    method: 'get',
    params: params
  })
}

// 创建大淘客淘口令接口
export function GetPrivilegeLink(params) {
  return axios({
    url: '/SaleV2/Dtk/GetPrivilegeLink',
    method: 'get',
    params: params
  })
}
